<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("driver")}}</h4>
                <p class="text-subtitle">{{$t("driver_creatino_form")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <DriverForm
                    :name.sync="form.name"
                    :phone.sync="form.phone"
                    ref="form"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t("save")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3" @click="handleCancel">
                <v-btn depressed block>
                    {{$t("cancel")}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import DriverForm from './../../components/fleet/DriverForm.vue';
import service from './../../services/fleet/driver';
import PAlert from './../../components/common/PAlert.vue';
import { v4 as uuid } from 'uuid';

export default {
    components: {
        DriverForm,
        PAlert
    },
    data() {
        return {
            form: {
                name: "",
                phone: ""
            },
            loading: false,
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            idempotentKey: null
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.create({...this.form, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({ name: "DriverDisplay", params: { driverID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>